import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PaginationParams } from "../../models/pagination-params";

@Component({
    selector: "app-pagination",
    templateUrl: "./pagination.component.html",
    styleUrls: ["./pagination.component.scss"],
})
export class PaginationComponent {
    @Input() params: PaginationParams;
    @Input() term;
    @Input() hidePageNumber = false;
    @Output() update = new EventEmitter<any>();
    @Output() action = new EventEmitter<[pagingAction, any]>();

    setPage(page) {
        this.params.page = page;
        this.update.emit(this.params);
    }

    first() {
        this.params.page = 0;
        this.update.emit(this.params);
    }

    last() {
        this.params.page = this.params.pages - 1;
        this.update.emit(this.params);
    }

    previous() {
        if (this.params.prevUrl) {
            // only prev URL logic
            this.params.page--; // need this in order to keep track of what is loaded
            this.action.emit([pagingAction.previous, this.params]);
        } else if (this.params.page !== 0) {
            this.params.page--;
            this.update.emit(this.params);
        }
    }

    next() {
        if (this.params.nextUrl) {
            // only next page logic
            this.params.page++; // need this in order to keep track of what is loaded
            this.action.emit([pagingAction.next, this.params]);
        } else if (this.params.page + 1 < this.params.pages) {
            this.params.page++;
            this.update.emit(this.params);
        }
    }

    showPageNumber(pageNo) {
        const backLimit = this.params.page - 3;
        const forwardLimit = this.params.page + 3;

        if (this.params.page < 3 && pageNo < 5) {
            return true;
        } else {
            if (pageNo > backLimit && pageNo < forwardLimit) {
                return true;
            } else {
                if (
                    pageNo + 6 > this.params.pages &&
                    this.params.page + 6 > this.params.pages &&
                    pageNo < forwardLimit
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    changeLimit(limit) {
        this.params.limit = limit;
        this.params.page = 0;
        this.update.emit(this.params);
    }
}

export enum pagingAction {
    next,
    previous,
}
